import { styled } from "@/stitches/config"

export const SAccordionItem = styled("div", {
  paddingBottom: "$24",

  lastOfType: {
    paddingBottom: 0,
  },
})
